import { Colors, TextColorNames } from "@smartsuite/types";
// TODO: localize labels
export const colors = [
    {
        label: "Default",
        value: TextColorNames.primary,
        class: "default",
    },
    {
        label: "White",
        value: "rgb(255,255,255)",
        class: "white",
    },
    {
        label: "Gray",
        value: TextColorNames.secondary,
        class: "gray",
    },
    {
        label: "Brown",
        value: "rgb(100,71,58)",
        class: "brown",
    },
    {
        label: "Orange",
        value: Colors.bOrange,
        class: "orange",
    },
    {
        label: "Yellow",
        value: Colors.bYellow,
        class: "yellow",
    },
    {
        label: "Green",
        value: Colors.bGreen,
        class: "green",
    },
    {
        label: "Blue",
        value: Colors.bBlue,
        class: "blue",
    },
    {
        label: "Purple",
        value: Colors.bPurple,
        class: "purple",
    },
    {
        label: "Pink",
        value: Colors.bPink,
        class: "pink",
    },
    {
        label: "Red",
        value: Colors.bRed,
        class: "red",
    },
];
